
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {ApprovalStep} from '../../../models/approvalStep';
  import {Voucher} from "../../../models/voucherI";

  @Component({
    components: {},
  })
  export default class VoucherDetailsSignatures extends Vue {

    @Prop({default: null})
    voucher: Voucher;

    private approvalStepList: ApprovalStep[] = [];

    private roleLabels: { [key: string]: string } = {
      ROLE_MOHTAMIM: 'Mohtamim',
      ROLE_MOHTAMIM_MUHASIB: 'Muhasib',
      ROLE_MOAWIN_MUHASIB: 'Moawin Muhasib',
      ROLE_NAZIMEALA_IJTEMA: 'Nazim-e-Ala Ijtema',
      ROLE_SADR_MAJLIS: 'Sadr Majlis',
      ROLE_MOHTAMIM_MAAL: 'Maal',
      ROLE_MOHTAMIM_MAAL_ASSISTANT: 'Maal',
    };

    private statusLabels: { [key: string]: string } = {
      APPROVED: 'genehmigt',
      DECLINED: 'abgelehnt',
      ARCHIVED: 'archiviert',
      PARKED: 'geparkt',
      UNPARKED: 'aktiviert',
    };

    // "<Name> (<AIMS-ID>) - <status> als <Rolle>"; steps without AIMS-ID (pre SSO): "<status> als <Rolle>"
    stepLabel(as: ApprovalStep): string {
      const parts: string[] = [];
      if (as.approverName) {
        parts.push(as.approverName + (as.approver ? ' (' + as.approver + ')' : ''));
      } else if (as.approver) {
        parts.push(as.approver);
      }
      if (as.approverRole) {
        const action = this.statusLabels[as.status || ''] || '';
        parts.push((action + ' als ' + (this.roleLabels[as.approverRole] || as.approverRole)).trim());
      }
      return parts.join(' - ');
    }

    created() {
      //@ts-ignore
      this.approvalStepList = [...this.voucher.approvalStepList];
      //@ts-ignore
      this.approvalStepList
      //@ts-ignore
        .sort(function (a, b) {
          if (new Date(a.createDate) < new Date(b.createDate)) return -1;
          if (new Date(a.createDate) > new Date(b.createDate)) return 1;
          return 0;
        });
    }
  }
